module.exports = __webpack_public_path__ + "img/philosophy-building.ed0e6536.png";